<template>
  <div id="paginaAllegatiDE">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Download Allegati D ed E</b-card-title>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-datepicker
                  id="dataInizio" v-model="dataInizio" start="Decade" depth="Year"
                  :format="settings.formatoMese" placeholder="Inizio" />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-datepicker
                  id="dataFine" v-model="dataFine" start="Decade" depth="Year"
                  :format="settings.formatoMese" placeholder="Fine" />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="cercaModelloD" @click.native="ricercaD()" >
                  Dati Allegato D
                </ejs-button>
              </b-col>
            </b-row>
            <b-row class="pt-5">
              <b-col xl="4" md="4" class="mb-2">
                <label for="annoRiferimento" class="h5">Anno di Riferimento</label>
                <ejs-dropdownlist id="annoRiferimento" v-model="annoRiferimento"
                                  :dataSource="annoRiferimentoList" :fields="annoRiferimentoFields" :allowFiltering="true"
                                  placeholder="Anno di Riferimento" />
              </b-col>

              <b-col xl="4" md="4" class="mb-2">
                <label for="meseRiferimento" class="h5">Mese di Riferimento</label>
                <ejs-dropdownlist id="meseRiferimento" ref="meseRiferimento" v-model="meseRiferimento"
                                  :dataSource="meseRiferimentoList" :fields="meseRiferimentoFields" :allowFiltering="true"
                                  placeholder="Mese di Riferimento" />
              </b-col>

              <b-col xl="4" md="4" class="pt-1">
                <ejs-button id="cercaModelloC2" @click.native="ricercaC2()" >
                  Dati Allegato E
                </ejs-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, LinkPlugin, AlertPlugin, ProgressPlugin,
  ToastPlugin, SpinnerPlugin,
} from 'bootstrap-vue'
// import Vuexy
// import Syncfusion

import { enableRipple, setCulture, L10n, setCurrencyCode } from '@syncfusion/ej2-base'
//import { Query } from '@syncfusion/ej2-data'
import {
  TextBoxPlugin, NumericTextBoxPlugin,
} from '@syncfusion/ej2-vue-inputs'
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import {
  DropDownListPlugin,
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Toolbar, ExcelExport,
  Aggregate, Sort
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

L10n.load({
  'it-IT': {
    'grid': {
      'ConfirmDelete': 'Sei sicuro di cancellare? Clicca OK per confermare la cancellazione, CANCEL per annullare'
    },
    'calendar': { today: 'oggi' } // per cambiare la lingua nei calendar e data occorre qualche passaggio in più (https://ej2.syncfusion.com/vue/documentation/calendar/globalization)
  }
});

const axios = require('axios')
// use bootstrap-vue
Vue.use(LayoutPlugin)
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(DropdownPlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(SpinnerPlugin)
// use Syncfusion
Vue.use(DatePickerPlugin)
Vue.use(ButtonPlugin)
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(DropDownListPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
enableRipple(true)
// api
const apiModuloC1Ricerca = '/demo/api/moduloc1/anno'
const apiModuloD = '/demo/api/moduloc2/prova'
const apiModuloC2Ricerca = '/demo/api/moduloc2/genera'

export default Vue.extend({
  components: {
  },
    data() {
        const oggi = new Date();
        const meseCorrente = oggi.getMonth() + 1;
        const annoCorrente = oggi.getFullYear().toString();
        const meseRif = String(meseCorrente).padStart(2, '0');
    return {
      loading: false,
      annoRiferimentoList: [
        { label: "Anno 2024", val: "2024" },
        { label: "Anno 2025", val: "2025" },
        { label: "Anno 2026", val: "2026" },
      ],
      annoRiferimentoFields: { value: "val", text: "label" },

      // per gestione meseRiferimento
      meseRiferimentoList: [
        { label: "Gennaio", val: "01" },
        { label: "Febbraio", val: "02" },
        { label: "Marzo", val: "03" },
        { label: "Aprile", val: "04" },
        { label: "Maggio", val: "05" },
        { label: "Giugno", val: "06" },
        { label: "Luglio", val: "07" },
        { label: "Agosto", val: "08" },
        { label: "Settembre", val: "09" },
        { label: "Ottobre", val: "10" },
        { label: "Novembre", val: "11" },
        { label: "Dicembre", val: "12" },
      ],
      meseRiferimentoFields: { value: "val", text: "label" },
      dataInizio: oggi,
      dataFine: oggi,
      mese: meseCorrente,
      annoRiferimento: annoCorrente,
      meseRiferimento: meseRif,

      // gestione elementi nascosti
      nonMostrare: false,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        formatoMese: "MMMM yyyy", // da usare per i datepicker
      },
      // costoProduzioni
      oneriFullData: [], // elenco completo dati costoProduzioni
      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per gridA
      gridAFlag: false,
      gridA: {
            height: 300,
            editOptions: {
                allowEditing: false,
                allowDeleting: false,
            },
            filterOptions: { type: 'Excel' },
        }, //
    }
  },
  created() {
    // log
    console.log('Pagina Download Modello C1 e C2 creata')
  },
  mounted() {
    // disabilito gridA
    // this.$refs.gridA.$el.classList.add('disablegrid')
    // document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    // this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    grid: [Toolbar, ExcelExport, Aggregate, Sort],
  },
  methods: {
    ricercaC1: function(args) {
      console.log(this.dataInizio)
      console.log(this.dataFine)
      const datiDaInviare = {
        dataInizio: this.dataInizio,
        dataFine: this.dataFine,
      };
      useJwt.post(apiModuloC1Ricerca, datiDaInviare, { responseType: "blob" }).then((response) => {
          // gestione risposta
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          console.log(response.headers)
          let fileName = response.headers["content-disposition"].split("filename=")[1];
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
      })
    },
    ricercaD: function(args) {
      const datiDaInviare = {
        dataInizio: this.dataInizio,
        dataFine: this.dataFine,
      };
      useJwt.post(apiModuloD, datiDaInviare, { responseType: "blob" }).then((response) => {
          // gestione risposta
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          console.log(response.headers)
          let fileName = response.headers["content-disposition"].split("filename=")[1];
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
      })
    },
    ricercaC2: function(args) {
      console.log(this.annoRiferimento)
      console.log(this.meseRiferimento)
      const datiDaInviare = {
        anno: this.annoRiferimento,
        mese: this.meseRiferimento,
      };
      useJwt.post(apiModuloC2Ricerca, datiDaInviare, { responseType: "blob" }).then((response) => {
          // gestione risposta
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          console.log(response.headers)
          let fileName = response.headers["content-disposition"].split("filename=")[1];
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
      })
    },
    noop() {
      console.log("premuto enter")
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
